// @NOTE: assumes jQuery is included by WP
const $ = jQuery

class header {
  constructor () {
    this.$body                = $('body')
    this.$jsOpenSearchBox     = $('.js-open-search-box')
    this.$jsCloseSearchBox    = $('.js-close-search-box')
    this.$searchBox           = $('.search-box');
    this.$jsOpenMobileMenu    = $('.js-open-mobile-menu')
    this.$jsCloseMobileMenu   = $('.js-close-mobile-menu')
    this.$mainMenu            = $('.main-menu')
    this.$mainMenuList        = $('#menu-main-menu')
    this.$searchField        = $('.search-input')
    this.$clearSearchBtn      = $('#clear-search');

    this.$jsOpenSearchBox.on('click', (event) => {
      event.preventDefault()
      const $clickedButton = $(event.currentTarget)
      this.openSearchBox($clickedButton)
    })

    this.$jsOpenSearchBox.on('keydown', (event) => {
      if (event.key === ' ' || event.key === 'Enter' || event.keyCode === 32 || event.keyCode === 13) {
        event.preventDefault()
        const $clickedButton = $(event.currentTarget)
        this.openSearchBox($clickedButton)
      }
    })

    this.$jsCloseSearchBox.on('click', (event) => {
      event.preventDefault()
      this.closeSearchBox()
    })

    $(document).on('keydown', (event) => {
      if ((event.key === 'Escape' || event.keyCode === 27) && !this.$searchBox.hasClass('invisible')) {
        this.closeSearchBox()
        this.$jsOpenSearchBox.focus()
      }
    })

    $(document).on('click', (event) => {
      const $target = $(event.target)
      if (!this.$searchBox.hasClass('invisible') &&
          !$target.closest('.search-box').length &&
          !$target.closest('.js-open-search-box').length) {
        this.closeSearchBox()
      }
    })

    this.$jsOpenMobileMenu.on('click keydown', (event) => {
      const isClick = event.type === 'click'
      const isEnter = event.type === 'keydown' && event.key === 'Enter'
      const isSpace = event.type === 'keydown' && (event.key === ' ' || event.code === 'Space')

      if (isClick || isEnter || isSpace) {
        event.preventDefault()
        const $clickedButton = $(event.currentTarget)
        this.openMobileMenu($clickedButton)
      }
    })

    this.$jsCloseMobileMenu.on('click keydown', (event) => {
      const isClick = event.type === 'click'
      const isEnter = event.type === 'keydown' && event.key === 'Enter'
      const isSpace = event.type === 'keydown' && (event.key === ' ' || event.code === 'Space')

      if (isClick || isEnter || isSpace) {
        event.preventDefault()
        const $clickedButton = $(event.currentTarget)
        this.closeMobileMenu($clickedButton)
      }
    })

    const toggleClearButton = ($input) => {
      const $btn = $input.siblings('#clear-search');
      if ($input.val().length > 0) {
        $btn.removeClass('hidden');
      } else {
        $btn.addClass('hidden');
      }
    }

    this.$searchField.each(function() {
      toggleClearButton($(this));
    });

    $(document).on('input', '.search-input', function() {
      toggleClearButton($(this));
    });

    $(document).on('change', '.search-input', function() {
      toggleClearButton($(this));
    });

    $(document).on('click', '#clear-search', function() {
      const $input = $(this).siblings('.search-input');
      $input.val('').focus();
      $(this).addClass('hidden');
    });
  }

  openSearchBox ($clickedButton) {
    this.$searchBox.removeClass('invisible').removeClass('opacity-0')
    this.$jsCloseSearchBox.removeClass('invisible').removeClass('opacity-0')
    this.$body.addClass('overflow-hidden')
    this.$searchField.focus()
    $clickedButton.addClass('active')
  }

  closeSearchBox () {
    this.$searchBox.addClass('invisible').addClass('opacity-0')
    this.$jsCloseSearchBox.addClass('invisible').addClass('opacity-0')
    this.$body.removeClass('overflow-hidden')
    this.$jsOpenSearchBox.removeClass('active')
  }

  openMobileMenu ($clickedButton) {
    this.$mainMenu.addClass('open')
    this.$jsCloseMobileMenu.removeClass('hidden')
    $clickedButton.addClass('hidden')
  }

  closeMobileMenu ($clickedButton) {
    this.$mainMenu.removeClass('open')
    this.$jsOpenMobileMenu.removeClass('hidden')
    $clickedButton.addClass('hidden')
    this.$searchBox.addClass('opacity-0').addClass('invisible')
  }

  onWindowResize (windowWidth) {
    //console.log('header.js onWindowResize')
  }
}

export default header